import { useEffect, useRef } from 'react';
import { Box, Card, CardHeader, Divider, TextField, Button } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InputMask from 'react-input-mask';
import * as Yup from 'yup';
import { Formik } from 'formik';

import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { getSubscriptionInfoAction } from '../../store/actions/subscription';
import { logoutAction } from '../../store/actions/profile';

import { LoadingButton, Tooltip } from '../common';
import { useAlert } from '../../hooks';

import { checkIpValue } from '../../utils';
import api from '../../api';

const initialValues = {
	ip: '',
};

const validationSchema = Yup.object().shape({
	ip: Yup.string().matches(
		'^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\\.|$)){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$',
		'Wrong IP',
	),
});

function ApiManagment() {
	const formikRef = useRef();
	const callAlert = useAlert();
	const dispatch = useDispatch();

	const { apiKey, ip: ipDefaultValue, loading } = useSelector((state) => state.subscription, shallowEqual);

	// useEffect(() => {
	// 	if (ipDefaultValue) formikRef?.current?.setFieldValue?.('ip', ipDefaultValue);
	// }, [ipDefaultValue]);

	// const handleNewApikey = async () => {
	// 	try {
	// 		callAlert('Generated a new api key.', 'success');
	// 	} catch (error) {
	// 		console.error(error);
	// 		callAlert('Error creating api key. Try again or contact us.', 'error');
	// 	}
	// };

	// const onRemove = async (_apiKey) => {
	// 	try {
	// 		callAlert('Api key successfully deleted.', 'success');
	// 	} catch (error) {
	// 		console.error(error);
	// 		callAlert('Key deletion error. Try again or contact us.', 'error');
	// 	}
	// };

	// const onSubmit = async (reqData, formikContext) => {
	// 	const { ip } = reqData;
	// 	const { setFieldValue } = formikContext;
	// 	try {
	// 		const res = await api.updateSubscription({ ip });
	// 		if (res.data.status === 'ok') {
	// 			callAlert('Api key successfully updated.', 'success');
	// 			dispatch(getSubscriptionInfoAction());
	// 		} else {
	// 			callAlert('An error has occurred. Please try again.', 'error');
	// 			setFieldValue('ip', ip);
	// 		}
	// 	} catch (error) {
	// 		console.error(error);
	// 		if (error.response.status === 401) {
	// 			dispatch(logoutAction());
	// 			callAlert('The session has expired. Login required.', 'info');
	// 		} else {
	// 			callAlert('An error has occurred. Please contact us via the feedback form.', 'error');
	// 		}
	// 	}
	// };

	const handleClickCopyKey = (e) => {
		e.stopPropagation();
		navigator.clipboard.writeText(apiKey).then(() => callAlert('API key copied to clipboard.', 'success'));
	};

	const titleContent = (
		<Tooltip title="You must specify the IP address of the server from which API requests will be made.">
			<div style={{ display: 'flex', maxWidth: 'max-content' }}>
				{'API settings'}
				<InfoOutlinedIcon color="primary" style={{ marginLeft: '10px' }} />
			</div>
		</Tooltip>
	);

	return (
		!loading && (
			<Card>
				<CardHeader subheader="" title={titleContent} />
				<Divider />
{/*				<Box sx={{ display: 'flex', p: 2 }}>
					<Formik {...{ initialValues, validationSchema, onSubmit, innerRef: formikRef }}>
						{({
							errors,
							handleBlur,
							handleChange,
							handleSubmit,
							isSubmitting,
							touched,
							values,
							setFieldValue,
						}) => (
							<form onSubmit={handleSubmit} style={{ display: 'flex'}}>
								<InputMask
									formatChars={{ 9: '[0-9.]' }}
									mask="999999999999999"
									maskChar={null}
									alwaysShowMask={false}
									beforeMaskedValueChange={(newState, oldState, userInput) => {
										let { value } = newState;
										const oldValue = oldState.value;
										let { selection } = newState;
										let cursorPosition = selection ? selection.start : null;
										const result = checkIpValue(value);
										if (!result) {
											value = value.trim();
											const newValue = `${value.substring(0, value.length - 1)}.${value.substring(
												value.length - 1,
											)}`;
											if (checkIpValue(newValue)) {
												// eslint-disable-next-line no-plusplus
												cursorPosition++;
												selection = { start: cursorPosition, end: cursorPosition };
												value = newValue;
											} else {
												value = oldValue;
											}
										}
										return { value, selection };
									}}
									disabled={false}
									value={values.ip}
									onChange={(e) => setFieldValue('ip', e.target.value)}
									onBlur={handleBlur}
								>
									{() => (
										<TextField
											error={Boolean(values.ip === '' || (touched.ip && errors.ip))}
											helperText={touched.ip && errors.ip}
											label="IP address of the server"
											margin="normal"
											name="confirm"
											type="text"
											variant="outlined"
											size="small"
											style={{ margin: 0,  maxWidth: '300px' }}
										/>
									)}
								</InputMask>
								<LoadingButton
									style={{ marginLeft: '20px', width: '90px', height: 40 }}
									color="primary"
									fullWidth
									size="small"
									type="submit"
									variant="contained"
									disabled={isSubmitting}
									loading={isSubmitting}
								>
									update
								</LoadingButton>
							</form>
						)}
					</Formik>
				</Box>
*/}				<Divider />
				{/* <ApiKey {...{ apiKey, onRemove }} /> */}
				<Box sx={{ display: 'flex', p: 2 }}>
					<TextField
						label="Your API key"
						margin="normal"
						name="confirm"
						type="text"
						variant="outlined"
						size="small"
						value={apiKey || ''}
						style={{ margin: 0, maxWidth: '300px', cursor: 'default' }}
						onClick={handleClickCopyKey}
					/>
					<Button
						style={{ marginLeft: '20px', width: '90px', height: 40 }}
						color="primary"
						fullWidth
						size="small"
						type="submit"
						variant="contained"
						onClick={handleClickCopyKey}
					>
						copy
					</Button>
				</Box>
				{/* <Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end',
					p: 2,
					height: 68,
				}}
			>
				<Button color="primary" variant="contained" onClick={handleNewApikey}>
					New API key
				</Button>
			</Box> */}
			</Card>
		)
	);
}

export default ApiManagment;
